import axios from "../axios";
import { SingleListResponse, AllListsResponse } from "../types/lists.types";

export const getAdvancedSearchLists = async (listName: string) => {
  try {
    const response = await axios.get(`lists/${listName}`);
    return response.data.items;
  } catch (err) {
    throw new Error(err + " Failed to fetch list");
  }
};

export const getList = async (listName: string): Promise<SingleListResponse> => {
  try {
    const response = await axios.get(`lists/${listName}`);
    return response.data.items || response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch list");
  }
};

export const getAllLists = async (): Promise<AllListsResponse> => {
  try {
    const response = await axios.get(`lists`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch all lists");
  }
};
